var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtenze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 29.3334V25C9.33398 21.3181 12.3188 18.3334 16.0007 18.3334C19.6825 18.3334 22.6673 21.3181 22.6673 25V29.3334M21.0007 8.66669C21.0007 11.4281 18.7621 13.6667 16.0007 13.6667C13.2392 13.6667 11.0007 11.4281 11.0007 8.66669C11.0007 5.90526 13.2392 3.66669 16.0007 3.66669C18.7621 3.66669 21.0007 5.90526 21.0007 8.66669Z",
    stroke: "#191E1B",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtenze);
export default __webpack_public_path__ + "static/media/utenze.f1cd487fd881f589c7d1b2ef570ce596.svg";
export { ForwardRef as ReactComponent };